import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import Lenis from '@studio-freight/lenis'
import SplitType from 'split-type';
import { PopupWidget } from 'react-calendly';
import { animate, stagger, inView } from 'motion'
import ArticleTemplate from "../../../templates/articletemplate/articletemplate";
import Annoncement from "../../../components/announcement/announcement";
import NeoBannerApp from "../images/Prompt.webp";
import TestimonialAvatar from "../images/testimonial-avatar.png";
import FTMSense from "../images/ftm-intelligence.svg";
import NeoSearchTrans from "../images/search-transaction.svg";
import NeoBars from "../images/bars.svg";
import NeoUser from "../images/user.svg";
import NeoStacks from "../images/trans-chips.svg";
import NeoCaps from "../images/trans-caps.svg";
import NeoWalletIcon from "../images/wallet.svg";
import NeoSecuritytIcon from "../images/security.svg";
import NeoDataIcon from "../images/datacard.svg";
import NeoCheckIcon from "../images/check.svg";
import RouteCardSVG from "../images/route-card.svg";
import MetricsCardSVG from "../images/metric-card.svg";
import AdvisorImageAmazon from "../images/aws-logo.svg";
import AdvisorImageBarclay from "../images/barclay.svg";
import AdvisorImagePlexal from "../images/plexal.svg";
import AdvisorImageCyber from "../images/cyber-runway.svg";
import MatrixLineOne from "../images/matrix-1.svg";
import MatrixLineTwo from "../images/matrix-2.svg"
import MatrixLineThree from "../images/matrix-3.svg"
// import Announcement from "../images/aws-logo-alt.svg";
import Announcement from "../images/announce-intel.svg";
import "./index.scss";

const LandingAnnouncementContent = () => {

  const el = useRef();
  const tl = useRef();
  useEffect(() => {
    const selectAnimationTarget = gsap.utils.selector(el);
    tl.current = gsap
      .timeline()
      .from(selectAnimationTarget(".c-announcement__text"), {
        opacity: 0,
        y: -20,
        duration: 1,
      })
      .from(selectAnimationTarget(".c-announcement__logo"), {
        opacity: 0,
        y: 20,
        duration: 0.55,
      });
  }, []);



  return(

  <>
    <a
        href="https://www.linkedin.com/posts/saminu-salisu_hackathon-frauddetection-bilic-activity-7115253885136478208-5Wfx/?utm_source=share&utm_medium=member_desktop"
      target="_blank"
      rel="noopener noreferrer"
      ref={el}
    >
      <div className="c-announcement__text">
        <p>
          🎉🎉 <span>Bilic</span> won the intel AI hackathon {" "}
            {/* <span> Intel Corporation Liftoff program </span> */}
          <span className="d-none d-md-inline-block"> </span> {" "}
          🎉🎉{" "}
        </p>
      </div>
      <div className="c-announcement__logo">
        <img
            src={Announcement}
          alt=""
          className="d-none d-md-inline-block"
        />
        <span className="d-none d-md-inline-flex">
          Read More <i className="fas fa-chevron-circle-right"></i>
        </span>
      </div>
    </a>
  </>
)};

const ArticleTemplateHeroBgImgs = () => (
  <div className="">
    {/* <img
      src={BannerImageRight}
      alt=""
      className="bilic-article-template__hero__background bilic-article-template__hero__background-right"
    />
    <img
      src={BannerImageLeft}
      alt=""
      className="bilic-article-template__hero__background bilic-article-template__hero__background-left"
    /> */}

    <img
      src={NeoBannerApp}
      alt=""
      className="bilic-article-template__hero__background bilic-article-template__hero__background-training"
    />
  </div>
);

const ArticleTemplateHero = () => {
  const el = useRef();
  const q = gsap.utils.selector(el);

  useEffect(() => {
    el.current = gsap
      .timeline()
      .from(q('.hidetextref'), {
        y: '150%',
        ease: 'power4.out',
        duration: 0.5,
        delay: 0.4,
        stagger: 0.6,
      })

    const heading = new SplitType('#heading', { types: 'words' })
    const para = new SplitType('#para', { types: 'lines' });
    const heroElements = [...heading.words, ...para.lines];

    animate(heroElements, { y: [28, 0], opacity: [0, 1] }, { duration: 0.8, delay: stagger(0.6) });

    animate('.bilic-global-header', { y: [-28, 0], opacity: [0, 1] }, { duration: 1, delay: stagger(0.5) });

  }, [q]);

  return (
    <>
      <div className="col col-xl-7">
        <div className="bilic-article-template__hero__text">
          <div className="w-100" ref={el}>
            {/* <small>💥  Introducing risk assesment agent </small> */}
            <h1 className="heading heading--one">
              <span className="hidetextref">
                <span> Secure your organization</span>
              </span>
            </h1>
            <h1 className="heading heading--two">
              <span className="hidetextref">
                <span>
                  with <span></span> anti-spear
                </span>
              </span>
            </h1>
            <h1 className="heading heading--two">
              <span className="hidetextref">
                <span>
                  <small>
                    <span className="d-inline-flex d-md-none">and </span>{" "}
                    email phishing training
                  </small>
                </span>
              </span>
            </h1>
            <p id="para">
              The Anti Spear-Phishing simulation Training where your discernment
              is the key to security of your Organization. Step into the shoes
              of a company exec, like a CFO, and sift through emails generated
              by AI.
            </p>
            <div className="bilic-article-template__hero__links">
              <Link
                className="btn bilic-article-template__hero__links__btn"
                to="/contact"
              >
                Speak to Sales
              </Link>
              {/* <PopupWidget
                url="https://calendly.com/saminated/60-minutes"
                rootElement={document.getElementById('root')}
                text="Get in touch"
                textColor="#ffffff"
                color="#319795"
              /> */}

              <a
                className="btn bilic-article-template__hero__links__btn bilic-article-template__hero__links__btn-alt animateanchor"
                // target="_blank" href="https://youtu.be/mO9-S74hS2o?t=83" rel="noreferrer">
                // target="_blank" href="https://prod-hosted-rephraseai.s3-accelerate.amazonaws.com/videos/23aa18dd-e0ec-4200-856e-c2795926b1f7.mp4" rel="noreferrer">
                target="_blank"
                href="https://www.loom.com/share/627aef2a3119448d80765d8588f3195c"
                rel="noreferrer"
              >
                Watch a Demo
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

// const ArticleTemplateHeroIllustration = () => {
//   useEffect(() => {
//     gsap.registerPlugin(ScrollTrigger);
//     // const heroImage = document.querySelector(".bilic-article-template__hero__image");
//     // const scrollTarget = document.querySelector("bilic-article-template__content__solutions");

//     animate(".bilic-article-template__hero__image", { transform: 'perspective(1200px) translateX(0px) translateY(-100px) scale(1) rotate(0deg) rotateX(32deg) rotateY(0deg) translateZ(0px)', opacity: [0, 1] }, { duration: 0.8, delay: 0.5 });

//     gsap.to(".bilic-article-template__hero__image", {
//       transform: 'translateY(0px) rotateX(0deg)',
//       perspective: 'none',
//       duration: 2,//
//       ease: "power2.inOut",
//       scrollTrigger: {
//         trigger: '.animateanchor',
//         start: '00',
//       },
//     });


//   }, []);

//   return (
//     <div className="col col-md-10">
//       <div className="bilic-article-template__hero__image">
//         <>
//           <img
//             src={NeoBannerApp}
//             alt=""
//             className=""
//           />
//         </>
//       </div>
//     </div>
//   )
// };

const Training = () => {
  gsap.registerPlugin(ScrollTrigger);
  const tl = useRef();
  const t = gsap.utils.selector(tl);
  // const triggerStart = document.querySelector('.triggerstart');
  // const animation = gsap.timeline();
  useEffect(() => {
    const stacks = document.querySelectorAll('.stack');
    const spacer = 20;
    const minScale = 0.8;
    const distributor = gsap.utils.distribute({ base: minScale, amount: 0.2 });
    const heading = new SplitType('.bilic-article-template__content__tagline__heading', { types: 'lines' });


    tl.current = gsap
      .timeline({
        scrollTrigger: {
          trigger: '.bilic-landing__banner__manifest__advisors__slide',
          start: `top center+=100px`,
          end: '1500',
          // markers: true,
        }
      })
      .from(t('.bilic-article-template__content__heading h4'), {
        opacity: 0,
        y: -40,
        duration: 0.5,
        ease: "power4.out",
        stagger: 0.2,
      })
      .from(t('.bilic-article-template__content__heading p'), {
        opacity: 0,
        y: 20,
        duration: 0.6,
        ease: "power4.out",
        stagger: 0.4,
      })
      .from(t('.wraplast'), {
        opacity: 0,
        y: 20,
        duration: 0.7,
        ease: "power4.out",
        stagger: 0.2,
      })




    heading.lines.forEach((target) => {
      gsap.to(target, {
        backgroundPositionX: 0,
        ease: "none",
        scrollTrigger: {
          trigger: target,
          scrub: 1,
          start: "top center",
          end: "bottom center"
        }
      });
    });


    inView(".bilic-article-template__content__howto", ({ target }) => {
      animate(
        target.querySelector(".bilic-article-template__content__howto__header"),
        { opacity: 1, transform: "none" },
        { delay: 0.8, duration: 1, easing: [0.17, 0.55, 0.55, 1] }
      );
    });




    stacks.forEach((stack, index) => {

      const scaleVal = distributor(index, stacks[index], stacks);

      const tween = gsap.to(stack, {
        scrollTrigger: {
          trigger: stack,
          start: `top top`,
          scrub: true,
          // markers: true,
          invalidateOnRefresh: true
        },
        ease: "none",
        scale: scaleVal
      });

      ScrollTrigger.create({
        trigger: stack,
        start: `top-=${index * spacer} top`,
        endTrigger: '.bilic-article-template__content__form',
        end: 'center bottom',
        pin: true,
        pinSpacing: false,
        // markers: true,
        id: 'pin',
        invalidateOnRefresh: true,
      });
    });


    // const lenis = new Lenis({
    //   duration: 1.2,
    //   easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    //   direction: 'vertical', // vertical, horizontal
    //   gestureDirection: 'vertical', // vertical, horizontal, both
    //   smooth: true,
    //   mouseMultiplier: 1,
    //   smoothTouch: false,
    //   touchMultiplier: 2,
    //   infinite: false,
    // });

    // function raf(time) {
    //   lenis.raf(time)
    //   requestAnimationFrame(raf)
    // }

    // requestAnimationFrame(raf);

    // const lenisInstance = new Lenis({
    //   wrapper: document.querySelector("body"), // element which has overflow
    //   content: document.querySelector("main") // usually wrapper's direct child
    // });




  }, [t]);



  return (
    <>
      <Annoncement styleModifier="landing">
        <LandingAnnouncementContent />
      </Annoncement>

      <ArticleTemplate
        articletemplateherobgimgs={
          <ArticleTemplateHeroBgImgs></ArticleTemplateHeroBgImgs>
        }
        articletemplatehero={
          <ArticleTemplateHero ArticleTemplateHero></ArticleTemplateHero>
        }
        articletemplateheroposition="start"
        templatename="bilic-article-template-training"
      >
        <div className="c-glow">
          <div className="c-glow__wrap">
            <div className="c-glow c-glow--one"></div>
            <div className="c-glow c-glow--two"></div>
          </div>
          {/* <div class="c-glow__wrap c-glow__wrap--two">
      <div class="c-glow c-glow--two"></div>
		</div> */}
        </div>

        <div className="" ref={tl}>
          <section className="bilic-article-template__content__tagline">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-11">
                  <header className="d-flex flex-column align-items-center text-center">
                    <h2>How it works?</h2>
                    <p>
                      Strengthen Your Defense Against Targeted Cyber Threats
                    </p>
                  </header>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col">
                  <div className="bilic-article-template__content__features-wrap">
                    <div className="bilic-article-template__content__features__list">
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMView} alt="" /> */}
                        <h6>Train On Realistic Simulations</h6>
                        <p>
                          Engage in realistic and interactive simulations that
                          mimic actual spear phishing scenarios. Practice
                          identifying red flags and responding appropriately to
                          risky emails.
                        </p>
                      </div>
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMPrint} alt="" /> */}
                        <h6>Personalized Learning Paths</h6>
                        <p>
                          Tailor your training experience to your role and
                          responsibilities. Whether you're an executive, IT
                          professional, or team member, our program provides
                          targeted insights to enhance your security posture.
                        </p>
                      </div>
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMNote} alt="" /> */}
                        <h6>Immediate Feedback</h6>
                        <p>
                          Receive instant feedback on your performance, allowing
                          you to learn from mistakes and reinforce good security
                          practices.
                        </p>
                        <a href="https://medium.com/bilic-io">
                          Learn More{" "}
                          <i className="fa-solid fa-circle-chevron-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bilic-article-template__content__howto">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-11">
                  <header className="bilic-article-template__content__howto__header">
                    <h2>Steps at the forefront</h2>
                    <h4>Introduction</h4>
                    <p>
                      Welcome to our Anti-Spear Phishing Simulation Training! In
                      an era of sophisticated cyber threats, traditional
                      security measures are no longer enough. Spear phishing, a
                      highly targeted form of cyberattack, poses a significant
                      risk to organizations and individuals alike. Our training
                      program is designed to empower you with the knowledge and
                      skills needed to identify and thwart these targeted
                      threats.
                    </p>
                  </header>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-11">
                  <div className="row g-5">
                    <article>
                      <embed src="" type="" />
                    </article>
                  </div>
                </div>

                {/* <div className="col-lg-6">
              <div className="bilic-article-template__content__howto__grid">
                <div className="bilic-article-template__content__howto__steps bilic-article-template__content__howto__steps--two">
                  <h4>NEO, our AI Agent do?</h4>
                </div>
                <div className="bilic-article-template__content__howto__steps bilic-article-template__content__howto__steps--three">
                  <h4>NEO, our AI Agent do?</h4>
                </div>
              </div>
            </div> */}
              </div>
            </div>
          </section>

          <section className="bilic-article-template__content__teaser bilic-article-template__content__teaser-lefttext">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-11">
                  <div className="bilic-article-template__content__teaser-wrap">
                    <div className="bilic-article-template__content__teaser__text">
                      <h3>
                        Why <span>Anti-Spear Phishing</span> Training Matters
                      </h3>
                      <p>
                        Spear phishing attacks are designed to bypass
                        traditional security measures by targeting specific
                        individuals within an organization. These attacks often
                        involve personalized and convincing messages, making
                        them difficult to detect.
                      </p>
                      <p>
                        Our training equips you with the skills to recognize and
                        respond effectively to these threats, safeguarding your
                        personal and organizational assets.
                      </p>
                    </div>
                    <div className="bilic-article-template__content__teaser__illustration">
                      <header>
                        <h6>Email</h6>
                      </header>
                      <p>
                        <span>
                          Subject: Urgent Payment Approval Required for Vendor
                          Invoice #12345
                        </span>
                        <span>Dear Sarah,</span>
                        <span>
                          We have received a vendor invoice #12345 that requires
                          your approval for payment. Please review the attached
                          invoice and provide your authorization for processing
                          at your earliest convenience. Your prompt attention to
                          this matter is appreciated.
                        </span>
                        <span>Sincerely,Accounts Payable Manager</span>
                      </p>
                      <footer>
                        <button className="btn btn-hacker">Hacker</button>
                      <button className="btn btn-neutral">Not Hacker</button>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
              {/* <img src={BannerCurve} alt="" className="bilic-article-template__content__background-curve bilic-article-template__content__background-curve-two"/> */}
            </div>
          </section>

          <section className="bilic-article-template__content__benefit">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-11">
                  <header className="d-flex flex-column align-items-center text-center">
                    <h2>Who can benefit?</h2>
                    <p>
                      Experience simulated spear phishing attacks crafted to
                      mimic real-world scenarios.
                    </p>
                  </header>
                </div>
                <div className="">
                  <div className="col">
                    <div className="bilic-article-template__content__features__list">
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMView} alt="" /> */}
                        <h6>Business Executives</h6>
                        <p>
                          Protect sensitive company information and personal
                          data by understanding the risks associated with
                          targeted attacks.
                        </p>
                      </div>
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMPrint} alt="" /> */}
                        <h6>IT Professionals</h6>
                        <p>
                          Strengthen your organization's security infrastructure
                          with in-depth knowledge of spear phishing tactics.
                        </p>
                      </div>
                      <div className="bilic-article-template__content__features__list__item">
                        {/* <img src={FTMNote} alt="" /> */}
                        <h6>Employees</h6>
                        <p>
                          Develop a vigilant mindset and contribute to a secure
                          workplace by recognizing and reporting potential
                          threats.
                        </p>
                        <a href="https://medium.com/bilic-io">
                          Learn More{" "}
                          <i className="fa-solid fa-circle-chevron-right"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bilic-article-template__content__testimonial">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-11">
                  <header className="d-flex flex-column align-items-center text-center">
                    <h6>Testimonials</h6>
                    <p>
                      Experience simulated spear phishing attacks crafted to
                      mimic real-world scenarios.
                    </p>
                  </header>
                </div>
                <div className="">
                  <div className="col">
                    <div className="bilic-article-template__content__testimonial__list">
                      <div className="bilic-article-template__content__testimonial__list__item">
                        <a href="">
                          <div className="bilic-article-template__content__testimonial__card">
                            <svg
                              width="96"
                              height="16"
                              viewBox="0 0 96 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.63852 0.838435C7.87667 0.787213 8.12292 0.787213 8.36108 0.838435C8.89084 0.952395 9.23324 1.37036 9.50172 1.81179C9.77332 2.25843 10.0591 2.88658 10.4102 3.65823L10.427 3.6952C10.6639 4.21594 10.7203 4.31131 10.7903 4.37351C10.8176 4.39775 10.8471 4.41933 10.8784 4.43796C10.9588 4.4858 11.0663 4.51028 11.6313 4.57625L11.7696 4.5924C12.5644 4.68518 13.2116 4.76072 13.6944 4.87452C14.1709 4.98681 14.65 5.16947 14.9268 5.60383C15.0872 5.85559 15.1804 6.14471 15.1976 6.44332C15.2273 6.9585 14.9464 7.38983 14.6264 7.76267C14.3023 8.1405 13.8228 8.58466 13.2339 9.13018L13.2057 9.15626C12.7659 9.5637 12.6893 9.65202 12.6523 9.74186C12.6337 9.78674 12.6209 9.83378 12.614 9.88186C12.6003 9.9781 12.6212 10.0935 12.7924 10.6701L12.8277 10.7889C13.1008 11.7088 13.3223 12.4548 13.4159 13.0303C13.5081 13.5972 13.5143 14.2006 13.1081 14.654C13.0055 14.7687 12.8881 14.8691 12.7592 14.9526C12.2491 15.2827 11.6588 15.1791 11.118 14.9959C10.5692 14.8097 9.87388 14.469 9.01644 14.0489L8.75372 13.9202C8.2166 13.657 8.10916 13.6191 8.00932 13.6183L7.99588 13.6184C7.89603 13.6199 7.7889 13.6587 7.25387 13.9262L7.01741 14.0444C6.15138 14.4775 5.4495 14.8283 4.89541 15.0208C4.35012 15.2103 3.75354 15.3191 3.23806 14.9841C3.11595 14.9047 3.00425 14.8103 2.90562 14.7027C2.48925 14.2491 2.49302 13.6386 2.5845 13.0651C2.67746 12.4824 2.89999 11.7259 3.17459 10.7923L3.21065 10.6697C3.38015 10.0934 3.40079 9.97818 3.38685 9.88202C3.37992 9.83426 3.36711 9.78754 3.34871 9.74298C3.31165 9.6533 3.23519 9.56506 2.7959 9.15818L2.76773 9.13202C2.17797 8.5857 1.69776 8.1409 1.37319 7.76252C1.05287 7.3891 0.771686 6.95707 0.802058 6.44111C0.819538 6.14402 0.912354 5.8564 1.07163 5.60569C1.34825 5.1703 1.82793 4.9872 2.30505 4.87468C2.78851 4.76065 3.43667 4.685 4.23271 4.59208L4.36826 4.57625C4.93331 4.51028 5.04081 4.4858 5.12119 4.43796C5.15251 4.41933 5.18201 4.39775 5.20928 4.37351C5.27931 4.31131 5.33565 4.21594 5.57257 3.6952L5.58936 3.6583C5.94043 2.88662 6.22623 2.25844 6.49787 1.81179C6.76635 1.37036 7.1087 0.952395 7.63852 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip1_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M27.6385 0.838435C27.8767 0.787213 28.1229 0.787213 28.3611 0.838435C28.8908 0.952395 29.2332 1.37036 29.5017 1.81179C29.7733 2.25843 30.0591 2.88658 30.4102 3.65823L30.427 3.6952C30.6639 4.21594 30.7203 4.31131 30.7903 4.37351C30.8176 4.39775 30.8471 4.41933 30.8784 4.43796C30.9588 4.4858 31.0663 4.51028 31.6313 4.57625L31.7696 4.5924C32.5644 4.68518 33.2116 4.76072 33.6944 4.87452C34.1709 4.98681 34.65 5.16947 34.9268 5.60383C35.0872 5.85559 35.1804 6.14471 35.1976 6.44332C35.2273 6.9585 34.9464 7.38983 34.6264 7.76267C34.3023 8.1405 33.8228 8.58466 33.2339 9.13018L33.2057 9.15626C32.7659 9.5637 32.6893 9.65202 32.6523 9.74186C32.6337 9.78674 32.6209 9.83378 32.614 9.88186C32.6003 9.9781 32.6212 10.0935 32.7924 10.6701L32.8277 10.7889C33.1008 11.7088 33.3223 12.4548 33.4159 13.0303C33.5081 13.5972 33.5143 14.2006 33.1081 14.654C33.0055 14.7687 32.8881 14.8691 32.7592 14.9526C32.2491 15.2827 31.6588 15.1791 31.118 14.9959C30.5692 14.8097 29.8739 14.469 29.0164 14.0489L28.7537 13.9202C28.2166 13.657 28.1092 13.6191 28.0093 13.6183L27.9959 13.6184C27.896 13.6199 27.7889 13.6587 27.2539 13.9262L27.0174 14.0444C26.1514 14.4775 25.4495 14.8283 24.8954 15.0208C24.3501 15.2103 23.7535 15.3191 23.2381 14.9841C23.1159 14.9047 23.0042 14.8103 22.9056 14.7027C22.4892 14.2491 22.493 13.6386 22.5845 13.0651C22.6775 12.4824 22.9 11.7259 23.1746 10.7923L23.2106 10.6697C23.3802 10.0934 23.4008 9.97818 23.3868 9.88202C23.3799 9.83426 23.3671 9.78754 23.3487 9.74298C23.3116 9.6533 23.2352 9.56506 22.7959 9.15818L22.7677 9.13202C22.178 8.5857 21.6978 8.1409 21.3732 7.76252C21.0529 7.3891 20.7717 6.95707 20.8021 6.44111C20.8195 6.14402 20.9124 5.8564 21.0716 5.60569C21.3482 5.1703 21.8279 4.9872 22.305 4.87468C22.7885 4.76065 23.4367 4.685 24.2327 4.59208L24.3683 4.57625C24.9333 4.51028 25.0408 4.4858 25.1212 4.43796C25.1525 4.41933 25.182 4.39775 25.2093 4.37351C25.2793 4.31131 25.3356 4.21594 25.5726 3.6952L25.5894 3.6583C25.9404 2.88662 26.2262 2.25844 26.4979 1.81179C26.7663 1.37036 27.1087 0.952395 27.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip2_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M47.6385 0.838435C47.8767 0.787213 48.1229 0.787213 48.3611 0.838435C48.8908 0.952395 49.2332 1.37036 49.5017 1.81179C49.7733 2.25843 50.0591 2.88658 50.4102 3.65823L50.427 3.6952C50.6639 4.21594 50.7203 4.31131 50.7903 4.37351C50.8176 4.39775 50.8471 4.41933 50.8784 4.43796C50.9588 4.4858 51.0663 4.51028 51.6313 4.57625L51.7696 4.5924C52.5644 4.68518 53.2116 4.76072 53.6944 4.87452C54.1709 4.98681 54.65 5.16947 54.9268 5.60383C55.0872 5.85559 55.1804 6.14471 55.1976 6.44332C55.2273 6.9585 54.9464 7.38983 54.6264 7.76267C54.3023 8.1405 53.8228 8.58466 53.2339 9.13018L53.2057 9.15626C52.7659 9.5637 52.6893 9.65202 52.6523 9.74186C52.6337 9.78674 52.6209 9.83378 52.614 9.88186C52.6003 9.9781 52.6212 10.0935 52.7924 10.6701L52.8277 10.7889C53.1008 11.7088 53.3223 12.4548 53.4159 13.0303C53.5081 13.5972 53.5143 14.2006 53.1081 14.654C53.0055 14.7687 52.8881 14.8691 52.7592 14.9526C52.2491 15.2827 51.6588 15.1791 51.118 14.9959C50.5692 14.8097 49.8739 14.469 49.0164 14.0489L48.7537 13.9202C48.2166 13.657 48.1092 13.6191 48.0093 13.6183L47.9959 13.6184C47.896 13.6199 47.7889 13.6587 47.2539 13.9262L47.0174 14.0444C46.1514 14.4775 45.4495 14.8283 44.8954 15.0208C44.3501 15.2103 43.7535 15.3191 43.2381 14.9841C43.1159 14.9047 43.0042 14.8103 42.9056 14.7027C42.4892 14.2491 42.493 13.6386 42.5845 13.0651C42.6775 12.4824 42.9 11.7259 43.1746 10.7923L43.2106 10.6697C43.3802 10.0934 43.4008 9.97818 43.3868 9.88202C43.3799 9.83426 43.3671 9.78754 43.3487 9.74298C43.3116 9.6533 43.2352 9.56506 42.7959 9.15818L42.7677 9.13202C42.178 8.5857 41.6978 8.1409 41.3732 7.76252C41.0529 7.3891 40.7717 6.95707 40.8021 6.44111C40.8195 6.14402 40.9124 5.8564 41.0716 5.60569C41.3482 5.1703 41.8279 4.9872 42.305 4.87468C42.7885 4.76065 43.4367 4.685 44.2327 4.59208L44.3683 4.57625C44.9333 4.51028 45.0408 4.4858 45.1212 4.43796C45.1525 4.41933 45.182 4.39775 45.2093 4.37351C45.2793 4.31131 45.3356 4.21594 45.5726 3.6952L45.5894 3.6583C45.9404 2.88662 46.2262 2.25844 46.4979 1.81179C46.7663 1.37036 47.1087 0.952395 47.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip3_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M67.6385 0.838435C67.8767 0.787213 68.1229 0.787213 68.3611 0.838435C68.8908 0.952395 69.2332 1.37036 69.5017 1.81179C69.7733 2.25843 70.0591 2.88658 70.4102 3.65823L70.427 3.6952C70.6639 4.21594 70.7203 4.31131 70.7903 4.37351C70.8176 4.39775 70.8471 4.41933 70.8784 4.43796C70.9588 4.4858 71.0663 4.51028 71.6313 4.57625L71.7696 4.5924C72.5644 4.68518 73.2116 4.76072 73.6944 4.87452C74.1709 4.98681 74.65 5.16947 74.9268 5.60383C75.0872 5.85559 75.1804 6.14471 75.1976 6.44332C75.2273 6.9585 74.9464 7.38983 74.6264 7.76267C74.3023 8.1405 73.8228 8.58466 73.2339 9.13018L73.2057 9.15626C72.7659 9.5637 72.6893 9.65202 72.6523 9.74186C72.6337 9.78674 72.6209 9.83378 72.614 9.88186C72.6003 9.9781 72.6212 10.0935 72.7924 10.6701L72.8277 10.7889C73.1008 11.7088 73.3223 12.4548 73.4159 13.0303C73.5081 13.5972 73.5143 14.2006 73.1081 14.654C73.0055 14.7687 72.8881 14.8691 72.7592 14.9526C72.2491 15.2827 71.6588 15.1791 71.118 14.9959C70.5692 14.8097 69.8739 14.469 69.0164 14.0489L68.7537 13.9202C68.2166 13.657 68.1092 13.6191 68.0093 13.6183L67.9959 13.6184C67.896 13.6199 67.7889 13.6587 67.2539 13.9262L67.0174 14.0444C66.1514 14.4775 65.4495 14.8283 64.8954 15.0208C64.3501 15.2103 63.7535 15.3191 63.2381 14.9841C63.1159 14.9047 63.0042 14.8103 62.9056 14.7027C62.4892 14.2491 62.493 13.6386 62.5845 13.0651C62.6775 12.4824 62.9 11.7259 63.1746 10.7923L63.2106 10.6697C63.3802 10.0934 63.4008 9.97818 63.3868 9.88202C63.3799 9.83426 63.3671 9.78754 63.3487 9.74298C63.3116 9.6533 63.2352 9.56506 62.7959 9.15818L62.7677 9.13202C62.178 8.5857 61.6978 8.1409 61.3732 7.76252C61.0529 7.3891 60.7717 6.95707 60.8021 6.44111C60.8195 6.14402 60.9124 5.8564 61.0716 5.60569C61.3482 5.1703 61.8279 4.9872 62.305 4.87468C62.7885 4.76065 63.4367 4.685 64.2327 4.59208L64.3683 4.57625C64.9333 4.51028 65.0408 4.4858 65.1212 4.43796C65.1525 4.41933 65.182 4.39775 65.2093 4.37351C65.2793 4.31131 65.3356 4.21594 65.5726 3.6952L65.5894 3.6583C65.9404 2.88662 66.2262 2.25844 66.4979 1.81179C66.7663 1.37036 67.1087 0.952395 67.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip4_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M87.6385 0.838435C87.8767 0.787213 88.1229 0.787213 88.3611 0.838435C88.8908 0.952395 89.2332 1.37036 89.5017 1.81179C89.7733 2.25843 90.0591 2.88658 90.4102 3.65823L90.427 3.6952C90.6639 4.21594 90.7203 4.31131 90.7903 4.37351C90.8176 4.39775 90.8471 4.41933 90.8784 4.43796C90.9588 4.4858 91.0663 4.51028 91.6313 4.57625L91.7696 4.5924C92.5644 4.68518 93.2116 4.76072 93.6944 4.87452C94.1709 4.98681 94.65 5.16947 94.9268 5.60383C95.0872 5.85559 95.1804 6.14471 95.1976 6.44332C95.2273 6.9585 94.9464 7.38983 94.6264 7.76267C94.3023 8.1405 93.8228 8.58466 93.2339 9.13018L93.2057 9.15626C92.7659 9.5637 92.6893 9.65202 92.6523 9.74186C92.6337 9.78674 92.6209 9.83378 92.614 9.88186C92.6003 9.9781 92.6212 10.0935 92.7924 10.6701L92.8277 10.7889C93.1008 11.7088 93.3223 12.4548 93.4159 13.0303C93.5081 13.5972 93.5143 14.2006 93.1081 14.654C93.0055 14.7687 92.8881 14.8691 92.7592 14.9526C92.2491 15.2827 91.6588 15.1791 91.118 14.9959C90.5692 14.8097 89.8739 14.469 89.0164 14.0489L88.7537 13.9202C88.2166 13.657 88.1092 13.6191 88.0093 13.6183L87.9959 13.6184C87.896 13.6199 87.7889 13.6587 87.2539 13.9262L87.0174 14.0444C86.1514 14.4775 85.4495 14.8283 84.8954 15.0208C84.3501 15.2103 83.7535 15.3191 83.2381 14.9841C83.1159 14.9047 83.0042 14.8103 82.9056 14.7027C82.4892 14.2491 82.493 13.6386 82.5845 13.0651C82.6775 12.4824 82.9 11.7259 83.1746 10.7923L83.2106 10.6697C83.3802 10.0934 83.4008 9.97818 83.3868 9.88202C83.3799 9.83426 83.3671 9.78754 83.3487 9.74298C83.3116 9.6533 83.2352 9.56506 82.7959 9.15818L82.7677 9.13202C82.178 8.5857 81.6978 8.1409 81.3732 7.76252C81.0529 7.3891 80.7717 6.95707 80.8021 6.44111C80.8195 6.14402 80.9124 5.8564 81.0716 5.60569C81.3482 5.1703 81.8279 4.9872 82.305 4.87468C82.7885 4.76065 83.4367 4.685 84.2327 4.59208L84.3683 4.57625C84.9333 4.51028 85.0408 4.4858 85.1212 4.43796C85.1525 4.41933 85.182 4.39775 85.2093 4.37351C85.2793 4.31131 85.3356 4.21594 85.5726 3.6952L85.5894 3.6583C85.9404 2.88662 86.2262 2.25844 86.4979 1.81179C86.7663 1.37036 87.1087 0.952395 87.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_3625_112356">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                                <clipPath id="clip1_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(20)"
                                  />
                                </clipPath>
                                <clipPath id="clip2_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(40)"
                                  />
                                </clipPath>
                                <clipPath id="clip3_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(60)"
                                  />
                                </clipPath>
                                <clipPath id="clip4_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(80)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <p>
                              Bilic helped us to get started, but it will also
                              allow us to scale in the future. It was very quick
                              to set up.
                            </p>
                            <div
                              className="d-flex align-content-center justify-content-end"
                              style={{ gap: "8px" }}
                            >
                              <img src={TestimonialAvatar} alt="" />
                              <span className="d-flex flex-column align-align-items-center justify-content-center">
                                <h6>fascibake</h6>
                                <p>@fascibake</p>
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="bilic-article-template__content__testimonial__list__item">
                        <a href="">
                          <div className="bilic-article-template__content__testimonial__card">
                            <svg
                              width="96"
                              height="16"
                              viewBox="0 0 96 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.63852 0.838435C7.87667 0.787213 8.12292 0.787213 8.36108 0.838435C8.89084 0.952395 9.23324 1.37036 9.50172 1.81179C9.77332 2.25843 10.0591 2.88658 10.4102 3.65823L10.427 3.6952C10.6639 4.21594 10.7203 4.31131 10.7903 4.37351C10.8176 4.39775 10.8471 4.41933 10.8784 4.43796C10.9588 4.4858 11.0663 4.51028 11.6313 4.57625L11.7696 4.5924C12.5644 4.68518 13.2116 4.76072 13.6944 4.87452C14.1709 4.98681 14.65 5.16947 14.9268 5.60383C15.0872 5.85559 15.1804 6.14471 15.1976 6.44332C15.2273 6.9585 14.9464 7.38983 14.6264 7.76267C14.3023 8.1405 13.8228 8.58466 13.2339 9.13018L13.2057 9.15626C12.7659 9.5637 12.6893 9.65202 12.6523 9.74186C12.6337 9.78674 12.6209 9.83378 12.614 9.88186C12.6003 9.9781 12.6212 10.0935 12.7924 10.6701L12.8277 10.7889C13.1008 11.7088 13.3223 12.4548 13.4159 13.0303C13.5081 13.5972 13.5143 14.2006 13.1081 14.654C13.0055 14.7687 12.8881 14.8691 12.7592 14.9526C12.2491 15.2827 11.6588 15.1791 11.118 14.9959C10.5692 14.8097 9.87388 14.469 9.01644 14.0489L8.75372 13.9202C8.2166 13.657 8.10916 13.6191 8.00932 13.6183L7.99588 13.6184C7.89603 13.6199 7.7889 13.6587 7.25387 13.9262L7.01741 14.0444C6.15138 14.4775 5.4495 14.8283 4.89541 15.0208C4.35012 15.2103 3.75354 15.3191 3.23806 14.9841C3.11595 14.9047 3.00425 14.8103 2.90562 14.7027C2.48925 14.2491 2.49302 13.6386 2.5845 13.0651C2.67746 12.4824 2.89999 11.7259 3.17459 10.7923L3.21065 10.6697C3.38015 10.0934 3.40079 9.97818 3.38685 9.88202C3.37992 9.83426 3.36711 9.78754 3.34871 9.74298C3.31165 9.6533 3.23519 9.56506 2.7959 9.15818L2.76773 9.13202C2.17797 8.5857 1.69776 8.1409 1.37319 7.76252C1.05287 7.3891 0.771686 6.95707 0.802058 6.44111C0.819538 6.14402 0.912354 5.8564 1.07163 5.60569C1.34825 5.1703 1.82793 4.9872 2.30505 4.87468C2.78851 4.76065 3.43667 4.685 4.23271 4.59208L4.36826 4.57625C4.93331 4.51028 5.04081 4.4858 5.12119 4.43796C5.15251 4.41933 5.18201 4.39775 5.20928 4.37351C5.27931 4.31131 5.33565 4.21594 5.57257 3.6952L5.58936 3.6583C5.94043 2.88662 6.22623 2.25844 6.49787 1.81179C6.76635 1.37036 7.1087 0.952395 7.63852 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip1_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M27.6385 0.838435C27.8767 0.787213 28.1229 0.787213 28.3611 0.838435C28.8908 0.952395 29.2332 1.37036 29.5017 1.81179C29.7733 2.25843 30.0591 2.88658 30.4102 3.65823L30.427 3.6952C30.6639 4.21594 30.7203 4.31131 30.7903 4.37351C30.8176 4.39775 30.8471 4.41933 30.8784 4.43796C30.9588 4.4858 31.0663 4.51028 31.6313 4.57625L31.7696 4.5924C32.5644 4.68518 33.2116 4.76072 33.6944 4.87452C34.1709 4.98681 34.65 5.16947 34.9268 5.60383C35.0872 5.85559 35.1804 6.14471 35.1976 6.44332C35.2273 6.9585 34.9464 7.38983 34.6264 7.76267C34.3023 8.1405 33.8228 8.58466 33.2339 9.13018L33.2057 9.15626C32.7659 9.5637 32.6893 9.65202 32.6523 9.74186C32.6337 9.78674 32.6209 9.83378 32.614 9.88186C32.6003 9.9781 32.6212 10.0935 32.7924 10.6701L32.8277 10.7889C33.1008 11.7088 33.3223 12.4548 33.4159 13.0303C33.5081 13.5972 33.5143 14.2006 33.1081 14.654C33.0055 14.7687 32.8881 14.8691 32.7592 14.9526C32.2491 15.2827 31.6588 15.1791 31.118 14.9959C30.5692 14.8097 29.8739 14.469 29.0164 14.0489L28.7537 13.9202C28.2166 13.657 28.1092 13.6191 28.0093 13.6183L27.9959 13.6184C27.896 13.6199 27.7889 13.6587 27.2539 13.9262L27.0174 14.0444C26.1514 14.4775 25.4495 14.8283 24.8954 15.0208C24.3501 15.2103 23.7535 15.3191 23.2381 14.9841C23.1159 14.9047 23.0042 14.8103 22.9056 14.7027C22.4892 14.2491 22.493 13.6386 22.5845 13.0651C22.6775 12.4824 22.9 11.7259 23.1746 10.7923L23.2106 10.6697C23.3802 10.0934 23.4008 9.97818 23.3868 9.88202C23.3799 9.83426 23.3671 9.78754 23.3487 9.74298C23.3116 9.6533 23.2352 9.56506 22.7959 9.15818L22.7677 9.13202C22.178 8.5857 21.6978 8.1409 21.3732 7.76252C21.0529 7.3891 20.7717 6.95707 20.8021 6.44111C20.8195 6.14402 20.9124 5.8564 21.0716 5.60569C21.3482 5.1703 21.8279 4.9872 22.305 4.87468C22.7885 4.76065 23.4367 4.685 24.2327 4.59208L24.3683 4.57625C24.9333 4.51028 25.0408 4.4858 25.1212 4.43796C25.1525 4.41933 25.182 4.39775 25.2093 4.37351C25.2793 4.31131 25.3356 4.21594 25.5726 3.6952L25.5894 3.6583C25.9404 2.88662 26.2262 2.25844 26.4979 1.81179C26.7663 1.37036 27.1087 0.952395 27.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip2_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M47.6385 0.838435C47.8767 0.787213 48.1229 0.787213 48.3611 0.838435C48.8908 0.952395 49.2332 1.37036 49.5017 1.81179C49.7733 2.25843 50.0591 2.88658 50.4102 3.65823L50.427 3.6952C50.6639 4.21594 50.7203 4.31131 50.7903 4.37351C50.8176 4.39775 50.8471 4.41933 50.8784 4.43796C50.9588 4.4858 51.0663 4.51028 51.6313 4.57625L51.7696 4.5924C52.5644 4.68518 53.2116 4.76072 53.6944 4.87452C54.1709 4.98681 54.65 5.16947 54.9268 5.60383C55.0872 5.85559 55.1804 6.14471 55.1976 6.44332C55.2273 6.9585 54.9464 7.38983 54.6264 7.76267C54.3023 8.1405 53.8228 8.58466 53.2339 9.13018L53.2057 9.15626C52.7659 9.5637 52.6893 9.65202 52.6523 9.74186C52.6337 9.78674 52.6209 9.83378 52.614 9.88186C52.6003 9.9781 52.6212 10.0935 52.7924 10.6701L52.8277 10.7889C53.1008 11.7088 53.3223 12.4548 53.4159 13.0303C53.5081 13.5972 53.5143 14.2006 53.1081 14.654C53.0055 14.7687 52.8881 14.8691 52.7592 14.9526C52.2491 15.2827 51.6588 15.1791 51.118 14.9959C50.5692 14.8097 49.8739 14.469 49.0164 14.0489L48.7537 13.9202C48.2166 13.657 48.1092 13.6191 48.0093 13.6183L47.9959 13.6184C47.896 13.6199 47.7889 13.6587 47.2539 13.9262L47.0174 14.0444C46.1514 14.4775 45.4495 14.8283 44.8954 15.0208C44.3501 15.2103 43.7535 15.3191 43.2381 14.9841C43.1159 14.9047 43.0042 14.8103 42.9056 14.7027C42.4892 14.2491 42.493 13.6386 42.5845 13.0651C42.6775 12.4824 42.9 11.7259 43.1746 10.7923L43.2106 10.6697C43.3802 10.0934 43.4008 9.97818 43.3868 9.88202C43.3799 9.83426 43.3671 9.78754 43.3487 9.74298C43.3116 9.6533 43.2352 9.56506 42.7959 9.15818L42.7677 9.13202C42.178 8.5857 41.6978 8.1409 41.3732 7.76252C41.0529 7.3891 40.7717 6.95707 40.8021 6.44111C40.8195 6.14402 40.9124 5.8564 41.0716 5.60569C41.3482 5.1703 41.8279 4.9872 42.305 4.87468C42.7885 4.76065 43.4367 4.685 44.2327 4.59208L44.3683 4.57625C44.9333 4.51028 45.0408 4.4858 45.1212 4.43796C45.1525 4.41933 45.182 4.39775 45.2093 4.37351C45.2793 4.31131 45.3356 4.21594 45.5726 3.6952L45.5894 3.6583C45.9404 2.88662 46.2262 2.25844 46.4979 1.81179C46.7663 1.37036 47.1087 0.952395 47.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip3_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M67.6385 0.838435C67.8767 0.787213 68.1229 0.787213 68.3611 0.838435C68.8908 0.952395 69.2332 1.37036 69.5017 1.81179C69.7733 2.25843 70.0591 2.88658 70.4102 3.65823L70.427 3.6952C70.6639 4.21594 70.7203 4.31131 70.7903 4.37351C70.8176 4.39775 70.8471 4.41933 70.8784 4.43796C70.9588 4.4858 71.0663 4.51028 71.6313 4.57625L71.7696 4.5924C72.5644 4.68518 73.2116 4.76072 73.6944 4.87452C74.1709 4.98681 74.65 5.16947 74.9268 5.60383C75.0872 5.85559 75.1804 6.14471 75.1976 6.44332C75.2273 6.9585 74.9464 7.38983 74.6264 7.76267C74.3023 8.1405 73.8228 8.58466 73.2339 9.13018L73.2057 9.15626C72.7659 9.5637 72.6893 9.65202 72.6523 9.74186C72.6337 9.78674 72.6209 9.83378 72.614 9.88186C72.6003 9.9781 72.6212 10.0935 72.7924 10.6701L72.8277 10.7889C73.1008 11.7088 73.3223 12.4548 73.4159 13.0303C73.5081 13.5972 73.5143 14.2006 73.1081 14.654C73.0055 14.7687 72.8881 14.8691 72.7592 14.9526C72.2491 15.2827 71.6588 15.1791 71.118 14.9959C70.5692 14.8097 69.8739 14.469 69.0164 14.0489L68.7537 13.9202C68.2166 13.657 68.1092 13.6191 68.0093 13.6183L67.9959 13.6184C67.896 13.6199 67.7889 13.6587 67.2539 13.9262L67.0174 14.0444C66.1514 14.4775 65.4495 14.8283 64.8954 15.0208C64.3501 15.2103 63.7535 15.3191 63.2381 14.9841C63.1159 14.9047 63.0042 14.8103 62.9056 14.7027C62.4892 14.2491 62.493 13.6386 62.5845 13.0651C62.6775 12.4824 62.9 11.7259 63.1746 10.7923L63.2106 10.6697C63.3802 10.0934 63.4008 9.97818 63.3868 9.88202C63.3799 9.83426 63.3671 9.78754 63.3487 9.74298C63.3116 9.6533 63.2352 9.56506 62.7959 9.15818L62.7677 9.13202C62.178 8.5857 61.6978 8.1409 61.3732 7.76252C61.0529 7.3891 60.7717 6.95707 60.8021 6.44111C60.8195 6.14402 60.9124 5.8564 61.0716 5.60569C61.3482 5.1703 61.8279 4.9872 62.305 4.87468C62.7885 4.76065 63.4367 4.685 64.2327 4.59208L64.3683 4.57625C64.9333 4.51028 65.0408 4.4858 65.1212 4.43796C65.1525 4.41933 65.182 4.39775 65.2093 4.37351C65.2793 4.31131 65.3356 4.21594 65.5726 3.6952L65.5894 3.6583C65.9404 2.88662 66.2262 2.25844 66.4979 1.81179C66.7663 1.37036 67.1087 0.952395 67.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip4_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M87.6385 0.838435C87.8767 0.787213 88.1229 0.787213 88.3611 0.838435C88.8908 0.952395 89.2332 1.37036 89.5017 1.81179C89.7733 2.25843 90.0591 2.88658 90.4102 3.65823L90.427 3.6952C90.6639 4.21594 90.7203 4.31131 90.7903 4.37351C90.8176 4.39775 90.8471 4.41933 90.8784 4.43796C90.9588 4.4858 91.0663 4.51028 91.6313 4.57625L91.7696 4.5924C92.5644 4.68518 93.2116 4.76072 93.6944 4.87452C94.1709 4.98681 94.65 5.16947 94.9268 5.60383C95.0872 5.85559 95.1804 6.14471 95.1976 6.44332C95.2273 6.9585 94.9464 7.38983 94.6264 7.76267C94.3023 8.1405 93.8228 8.58466 93.2339 9.13018L93.2057 9.15626C92.7659 9.5637 92.6893 9.65202 92.6523 9.74186C92.6337 9.78674 92.6209 9.83378 92.614 9.88186C92.6003 9.9781 92.6212 10.0935 92.7924 10.6701L92.8277 10.7889C93.1008 11.7088 93.3223 12.4548 93.4159 13.0303C93.5081 13.5972 93.5143 14.2006 93.1081 14.654C93.0055 14.7687 92.8881 14.8691 92.7592 14.9526C92.2491 15.2827 91.6588 15.1791 91.118 14.9959C90.5692 14.8097 89.8739 14.469 89.0164 14.0489L88.7537 13.9202C88.2166 13.657 88.1092 13.6191 88.0093 13.6183L87.9959 13.6184C87.896 13.6199 87.7889 13.6587 87.2539 13.9262L87.0174 14.0444C86.1514 14.4775 85.4495 14.8283 84.8954 15.0208C84.3501 15.2103 83.7535 15.3191 83.2381 14.9841C83.1159 14.9047 83.0042 14.8103 82.9056 14.7027C82.4892 14.2491 82.493 13.6386 82.5845 13.0651C82.6775 12.4824 82.9 11.7259 83.1746 10.7923L83.2106 10.6697C83.3802 10.0934 83.4008 9.97818 83.3868 9.88202C83.3799 9.83426 83.3671 9.78754 83.3487 9.74298C83.3116 9.6533 83.2352 9.56506 82.7959 9.15818L82.7677 9.13202C82.178 8.5857 81.6978 8.1409 81.3732 7.76252C81.0529 7.3891 80.7717 6.95707 80.8021 6.44111C80.8195 6.14402 80.9124 5.8564 81.0716 5.60569C81.3482 5.1703 81.8279 4.9872 82.305 4.87468C82.7885 4.76065 83.4367 4.685 84.2327 4.59208L84.3683 4.57625C84.9333 4.51028 85.0408 4.4858 85.1212 4.43796C85.1525 4.41933 85.182 4.39775 85.2093 4.37351C85.2793 4.31131 85.3356 4.21594 85.5726 3.6952L85.5894 3.6583C85.9404 2.88662 86.2262 2.25844 86.4979 1.81179C86.7663 1.37036 87.1087 0.952395 87.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_3625_112356">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                                <clipPath id="clip1_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(20)"
                                  />
                                </clipPath>
                                <clipPath id="clip2_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(40)"
                                  />
                                </clipPath>
                                <clipPath id="clip3_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(60)"
                                  />
                                </clipPath>
                                <clipPath id="clip4_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(80)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <p>
                              Bilic helped us to get started, but it will also
                              allow us to scale in the future. It was very quick
                              to set up.
                            </p>
                            <div
                              className="d-flex align-content-center justify-content-end"
                              style={{ gap: "8px" }}
                            >
                              <img src={TestimonialAvatar} alt="" />
                              <span className="d-flex flex-column align-align-items-center justify-content-center">
                                <h6>fascibake</h6>
                                <p>@fascibake</p>
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                      <div className="bilic-article-template__content__testimonial__list__item">
                        <a href="">
                          <div className="bilic-article-template__content__testimonial__card">
                            <svg
                              width="96"
                              height="16"
                              viewBox="0 0 96 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clip-path="url(#clip0_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M7.63852 0.838435C7.87667 0.787213 8.12292 0.787213 8.36108 0.838435C8.89084 0.952395 9.23324 1.37036 9.50172 1.81179C9.77332 2.25843 10.0591 2.88658 10.4102 3.65823L10.427 3.6952C10.6639 4.21594 10.7203 4.31131 10.7903 4.37351C10.8176 4.39775 10.8471 4.41933 10.8784 4.43796C10.9588 4.4858 11.0663 4.51028 11.6313 4.57625L11.7696 4.5924C12.5644 4.68518 13.2116 4.76072 13.6944 4.87452C14.1709 4.98681 14.65 5.16947 14.9268 5.60383C15.0872 5.85559 15.1804 6.14471 15.1976 6.44332C15.2273 6.9585 14.9464 7.38983 14.6264 7.76267C14.3023 8.1405 13.8228 8.58466 13.2339 9.13018L13.2057 9.15626C12.7659 9.5637 12.6893 9.65202 12.6523 9.74186C12.6337 9.78674 12.6209 9.83378 12.614 9.88186C12.6003 9.9781 12.6212 10.0935 12.7924 10.6701L12.8277 10.7889C13.1008 11.7088 13.3223 12.4548 13.4159 13.0303C13.5081 13.5972 13.5143 14.2006 13.1081 14.654C13.0055 14.7687 12.8881 14.8691 12.7592 14.9526C12.2491 15.2827 11.6588 15.1791 11.118 14.9959C10.5692 14.8097 9.87388 14.469 9.01644 14.0489L8.75372 13.9202C8.2166 13.657 8.10916 13.6191 8.00932 13.6183L7.99588 13.6184C7.89603 13.6199 7.7889 13.6587 7.25387 13.9262L7.01741 14.0444C6.15138 14.4775 5.4495 14.8283 4.89541 15.0208C4.35012 15.2103 3.75354 15.3191 3.23806 14.9841C3.11595 14.9047 3.00425 14.8103 2.90562 14.7027C2.48925 14.2491 2.49302 13.6386 2.5845 13.0651C2.67746 12.4824 2.89999 11.7259 3.17459 10.7923L3.21065 10.6697C3.38015 10.0934 3.40079 9.97818 3.38685 9.88202C3.37992 9.83426 3.36711 9.78754 3.34871 9.74298C3.31165 9.6533 3.23519 9.56506 2.7959 9.15818L2.76773 9.13202C2.17797 8.5857 1.69776 8.1409 1.37319 7.76252C1.05287 7.3891 0.771686 6.95707 0.802058 6.44111C0.819538 6.14402 0.912354 5.8564 1.07163 5.60569C1.34825 5.1703 1.82793 4.9872 2.30505 4.87468C2.78851 4.76065 3.43667 4.685 4.23271 4.59208L4.36826 4.57625C4.93331 4.51028 5.04081 4.4858 5.12119 4.43796C5.15251 4.41933 5.18201 4.39775 5.20928 4.37351C5.27931 4.31131 5.33565 4.21594 5.57257 3.6952L5.58936 3.6583C5.94043 2.88662 6.22623 2.25844 6.49787 1.81179C6.76635 1.37036 7.1087 0.952395 7.63852 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip1_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M27.6385 0.838435C27.8767 0.787213 28.1229 0.787213 28.3611 0.838435C28.8908 0.952395 29.2332 1.37036 29.5017 1.81179C29.7733 2.25843 30.0591 2.88658 30.4102 3.65823L30.427 3.6952C30.6639 4.21594 30.7203 4.31131 30.7903 4.37351C30.8176 4.39775 30.8471 4.41933 30.8784 4.43796C30.9588 4.4858 31.0663 4.51028 31.6313 4.57625L31.7696 4.5924C32.5644 4.68518 33.2116 4.76072 33.6944 4.87452C34.1709 4.98681 34.65 5.16947 34.9268 5.60383C35.0872 5.85559 35.1804 6.14471 35.1976 6.44332C35.2273 6.9585 34.9464 7.38983 34.6264 7.76267C34.3023 8.1405 33.8228 8.58466 33.2339 9.13018L33.2057 9.15626C32.7659 9.5637 32.6893 9.65202 32.6523 9.74186C32.6337 9.78674 32.6209 9.83378 32.614 9.88186C32.6003 9.9781 32.6212 10.0935 32.7924 10.6701L32.8277 10.7889C33.1008 11.7088 33.3223 12.4548 33.4159 13.0303C33.5081 13.5972 33.5143 14.2006 33.1081 14.654C33.0055 14.7687 32.8881 14.8691 32.7592 14.9526C32.2491 15.2827 31.6588 15.1791 31.118 14.9959C30.5692 14.8097 29.8739 14.469 29.0164 14.0489L28.7537 13.9202C28.2166 13.657 28.1092 13.6191 28.0093 13.6183L27.9959 13.6184C27.896 13.6199 27.7889 13.6587 27.2539 13.9262L27.0174 14.0444C26.1514 14.4775 25.4495 14.8283 24.8954 15.0208C24.3501 15.2103 23.7535 15.3191 23.2381 14.9841C23.1159 14.9047 23.0042 14.8103 22.9056 14.7027C22.4892 14.2491 22.493 13.6386 22.5845 13.0651C22.6775 12.4824 22.9 11.7259 23.1746 10.7923L23.2106 10.6697C23.3802 10.0934 23.4008 9.97818 23.3868 9.88202C23.3799 9.83426 23.3671 9.78754 23.3487 9.74298C23.3116 9.6533 23.2352 9.56506 22.7959 9.15818L22.7677 9.13202C22.178 8.5857 21.6978 8.1409 21.3732 7.76252C21.0529 7.3891 20.7717 6.95707 20.8021 6.44111C20.8195 6.14402 20.9124 5.8564 21.0716 5.60569C21.3482 5.1703 21.8279 4.9872 22.305 4.87468C22.7885 4.76065 23.4367 4.685 24.2327 4.59208L24.3683 4.57625C24.9333 4.51028 25.0408 4.4858 25.1212 4.43796C25.1525 4.41933 25.182 4.39775 25.2093 4.37351C25.2793 4.31131 25.3356 4.21594 25.5726 3.6952L25.5894 3.6583C25.9404 2.88662 26.2262 2.25844 26.4979 1.81179C26.7663 1.37036 27.1087 0.952395 27.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip2_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M47.6385 0.838435C47.8767 0.787213 48.1229 0.787213 48.3611 0.838435C48.8908 0.952395 49.2332 1.37036 49.5017 1.81179C49.7733 2.25843 50.0591 2.88658 50.4102 3.65823L50.427 3.6952C50.6639 4.21594 50.7203 4.31131 50.7903 4.37351C50.8176 4.39775 50.8471 4.41933 50.8784 4.43796C50.9588 4.4858 51.0663 4.51028 51.6313 4.57625L51.7696 4.5924C52.5644 4.68518 53.2116 4.76072 53.6944 4.87452C54.1709 4.98681 54.65 5.16947 54.9268 5.60383C55.0872 5.85559 55.1804 6.14471 55.1976 6.44332C55.2273 6.9585 54.9464 7.38983 54.6264 7.76267C54.3023 8.1405 53.8228 8.58466 53.2339 9.13018L53.2057 9.15626C52.7659 9.5637 52.6893 9.65202 52.6523 9.74186C52.6337 9.78674 52.6209 9.83378 52.614 9.88186C52.6003 9.9781 52.6212 10.0935 52.7924 10.6701L52.8277 10.7889C53.1008 11.7088 53.3223 12.4548 53.4159 13.0303C53.5081 13.5972 53.5143 14.2006 53.1081 14.654C53.0055 14.7687 52.8881 14.8691 52.7592 14.9526C52.2491 15.2827 51.6588 15.1791 51.118 14.9959C50.5692 14.8097 49.8739 14.469 49.0164 14.0489L48.7537 13.9202C48.2166 13.657 48.1092 13.6191 48.0093 13.6183L47.9959 13.6184C47.896 13.6199 47.7889 13.6587 47.2539 13.9262L47.0174 14.0444C46.1514 14.4775 45.4495 14.8283 44.8954 15.0208C44.3501 15.2103 43.7535 15.3191 43.2381 14.9841C43.1159 14.9047 43.0042 14.8103 42.9056 14.7027C42.4892 14.2491 42.493 13.6386 42.5845 13.0651C42.6775 12.4824 42.9 11.7259 43.1746 10.7923L43.2106 10.6697C43.3802 10.0934 43.4008 9.97818 43.3868 9.88202C43.3799 9.83426 43.3671 9.78754 43.3487 9.74298C43.3116 9.6533 43.2352 9.56506 42.7959 9.15818L42.7677 9.13202C42.178 8.5857 41.6978 8.1409 41.3732 7.76252C41.0529 7.3891 40.7717 6.95707 40.8021 6.44111C40.8195 6.14402 40.9124 5.8564 41.0716 5.60569C41.3482 5.1703 41.8279 4.9872 42.305 4.87468C42.7885 4.76065 43.4367 4.685 44.2327 4.59208L44.3683 4.57625C44.9333 4.51028 45.0408 4.4858 45.1212 4.43796C45.1525 4.41933 45.182 4.39775 45.2093 4.37351C45.2793 4.31131 45.3356 4.21594 45.5726 3.6952L45.5894 3.6583C45.9404 2.88662 46.2262 2.25844 46.4979 1.81179C46.7663 1.37036 47.1087 0.952395 47.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip3_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M67.6385 0.838435C67.8767 0.787213 68.1229 0.787213 68.3611 0.838435C68.8908 0.952395 69.2332 1.37036 69.5017 1.81179C69.7733 2.25843 70.0591 2.88658 70.4102 3.65823L70.427 3.6952C70.6639 4.21594 70.7203 4.31131 70.7903 4.37351C70.8176 4.39775 70.8471 4.41933 70.8784 4.43796C70.9588 4.4858 71.0663 4.51028 71.6313 4.57625L71.7696 4.5924C72.5644 4.68518 73.2116 4.76072 73.6944 4.87452C74.1709 4.98681 74.65 5.16947 74.9268 5.60383C75.0872 5.85559 75.1804 6.14471 75.1976 6.44332C75.2273 6.9585 74.9464 7.38983 74.6264 7.76267C74.3023 8.1405 73.8228 8.58466 73.2339 9.13018L73.2057 9.15626C72.7659 9.5637 72.6893 9.65202 72.6523 9.74186C72.6337 9.78674 72.6209 9.83378 72.614 9.88186C72.6003 9.9781 72.6212 10.0935 72.7924 10.6701L72.8277 10.7889C73.1008 11.7088 73.3223 12.4548 73.4159 13.0303C73.5081 13.5972 73.5143 14.2006 73.1081 14.654C73.0055 14.7687 72.8881 14.8691 72.7592 14.9526C72.2491 15.2827 71.6588 15.1791 71.118 14.9959C70.5692 14.8097 69.8739 14.469 69.0164 14.0489L68.7537 13.9202C68.2166 13.657 68.1092 13.6191 68.0093 13.6183L67.9959 13.6184C67.896 13.6199 67.7889 13.6587 67.2539 13.9262L67.0174 14.0444C66.1514 14.4775 65.4495 14.8283 64.8954 15.0208C64.3501 15.2103 63.7535 15.3191 63.2381 14.9841C63.1159 14.9047 63.0042 14.8103 62.9056 14.7027C62.4892 14.2491 62.493 13.6386 62.5845 13.0651C62.6775 12.4824 62.9 11.7259 63.1746 10.7923L63.2106 10.6697C63.3802 10.0934 63.4008 9.97818 63.3868 9.88202C63.3799 9.83426 63.3671 9.78754 63.3487 9.74298C63.3116 9.6533 63.2352 9.56506 62.7959 9.15818L62.7677 9.13202C62.178 8.5857 61.6978 8.1409 61.3732 7.76252C61.0529 7.3891 60.7717 6.95707 60.8021 6.44111C60.8195 6.14402 60.9124 5.8564 61.0716 5.60569C61.3482 5.1703 61.8279 4.9872 62.305 4.87468C62.7885 4.76065 63.4367 4.685 64.2327 4.59208L64.3683 4.57625C64.9333 4.51028 65.0408 4.4858 65.1212 4.43796C65.1525 4.41933 65.182 4.39775 65.2093 4.37351C65.2793 4.31131 65.3356 4.21594 65.5726 3.6952L65.5894 3.6583C65.9404 2.88662 66.2262 2.25844 66.4979 1.81179C66.7663 1.37036 67.1087 0.952395 67.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <g clip-path="url(#clip4_3625_112356)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M87.6385 0.838435C87.8767 0.787213 88.1229 0.787213 88.3611 0.838435C88.8908 0.952395 89.2332 1.37036 89.5017 1.81179C89.7733 2.25843 90.0591 2.88658 90.4102 3.65823L90.427 3.6952C90.6639 4.21594 90.7203 4.31131 90.7903 4.37351C90.8176 4.39775 90.8471 4.41933 90.8784 4.43796C90.9588 4.4858 91.0663 4.51028 91.6313 4.57625L91.7696 4.5924C92.5644 4.68518 93.2116 4.76072 93.6944 4.87452C94.1709 4.98681 94.65 5.16947 94.9268 5.60383C95.0872 5.85559 95.1804 6.14471 95.1976 6.44332C95.2273 6.9585 94.9464 7.38983 94.6264 7.76267C94.3023 8.1405 93.8228 8.58466 93.2339 9.13018L93.2057 9.15626C92.7659 9.5637 92.6893 9.65202 92.6523 9.74186C92.6337 9.78674 92.6209 9.83378 92.614 9.88186C92.6003 9.9781 92.6212 10.0935 92.7924 10.6701L92.8277 10.7889C93.1008 11.7088 93.3223 12.4548 93.4159 13.0303C93.5081 13.5972 93.5143 14.2006 93.1081 14.654C93.0055 14.7687 92.8881 14.8691 92.7592 14.9526C92.2491 15.2827 91.6588 15.1791 91.118 14.9959C90.5692 14.8097 89.8739 14.469 89.0164 14.0489L88.7537 13.9202C88.2166 13.657 88.1092 13.6191 88.0093 13.6183L87.9959 13.6184C87.896 13.6199 87.7889 13.6587 87.2539 13.9262L87.0174 14.0444C86.1514 14.4775 85.4495 14.8283 84.8954 15.0208C84.3501 15.2103 83.7535 15.3191 83.2381 14.9841C83.1159 14.9047 83.0042 14.8103 82.9056 14.7027C82.4892 14.2491 82.493 13.6386 82.5845 13.0651C82.6775 12.4824 82.9 11.7259 83.1746 10.7923L83.2106 10.6697C83.3802 10.0934 83.4008 9.97818 83.3868 9.88202C83.3799 9.83426 83.3671 9.78754 83.3487 9.74298C83.3116 9.6533 83.2352 9.56506 82.7959 9.15818L82.7677 9.13202C82.178 8.5857 81.6978 8.1409 81.3732 7.76252C81.0529 7.3891 80.7717 6.95707 80.8021 6.44111C80.8195 6.14402 80.9124 5.8564 81.0716 5.60569C81.3482 5.1703 81.8279 4.9872 82.305 4.87468C82.7885 4.76065 83.4367 4.685 84.2327 4.59208L84.3683 4.57625C84.9333 4.51028 85.0408 4.4858 85.1212 4.43796C85.1525 4.41933 85.182 4.39775 85.2093 4.37351C85.2793 4.31131 85.3356 4.21594 85.5726 3.6952L85.5894 3.6583C85.9404 2.88662 86.2262 2.25844 86.4979 1.81179C86.7663 1.37036 87.1087 0.952395 87.6385 0.838435Z"
                                  fill="#31CF05"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_3625_112356">
                                  <rect width="16" height="16" fill="white" />
                                </clipPath>
                                <clipPath id="clip1_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(20)"
                                  />
                                </clipPath>
                                <clipPath id="clip2_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(40)"
                                  />
                                </clipPath>
                                <clipPath id="clip3_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(60)"
                                  />
                                </clipPath>
                                <clipPath id="clip4_3625_112356">
                                  <rect
                                    width="16"
                                    height="16"
                                    fill="white"
                                    transform="translate(80)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <p>
                              Bilic helped us to get started, but it will also
                              allow us to scale in the future. It was very quick
                              to set up.
                            </p>
                            <div
                              className="d-flex align-content-center justify-content-end"
                              style={{ gap: "8px" }}
                            >
                              <img src={TestimonialAvatar} alt="" />
                              <span className="d-flex flex-column align-align-items-center justify-content-center">
                                <h6>fascibake</h6>
                                <p>@fascibake</p>
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="bilic-article-template__content__cta">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col col-xl-10">
                  <div className="bilic-article-template__content__cta__wrap text-center d-flex flex-column align-items-center justify-content-center">
                    <h6>Get Started Today</h6>
                    <p>
                      Don't wait until it's too late. Strengthen your defense
                      against spear phishing attacks with our comprehensive
                      training program. Sign up today to start your journey
                      toward a more secure digital future.
                    </p>
                    <a
                      href=""
                      className="btn bilic-article-template__hero__links__btn"
                    >
                      {" "}
                      Get Started
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </ArticleTemplate>
    </>
  );
}

export default Training;
